import React , { useEffect, useState, useRef } from 'react'
// styles imports
import './TextInput.scss';

const TextInput = (props) => {
	// State準備
	const [type, setType] = useState(props.type ? props.type : "text")
	const [value, setValue] = useState(props.default);
	const isTouched = useRef(false);  // useRefで状態を管理
	const inputRef = useRef(null);
	const [validateInfo, setValidateInfo] = useState({ valid: true, message: null });

	useEffect(() => {
		if (isTouched.current) 
		{
			return
		}

		setValue(props.default)
	
	}, [props.default]);

	useEffect(() => {
		if (! props.value){
			return
		}
		if (inputRef.current) {
			inputRef.current.value = props.value; // DOMを直接操作
			setValue(props.value)
		}
	}, [props.value]);

	const clearValueFirst = () => {
		if (isTouched.current) 
		{
			return
		}

		if(props.firstClear)
		{
			setValue("");
		}
		
		isTouched.current = true;  // フラグを更新
	}

	const Validate = (val) => {
		const rules = props.rules ? props.rules : [];

		for (const rule of rules) {
			switch (rule.type) {
				case "required":
					if (!val || val.trim() === "") {
						return { valid: false, message: rule.message || "入力が必要です" };
					}
					break;

				case "minLength":
					if (val.length < rule.value) {
						return { valid: false, message: rule.message || `${rule.value}文字以上で入力してください` };
					}
					break;

				case "maxLength":
					if (val.length > rule.value) {
						return { valid: false, message: rule.message || `${rule.value}文字以内で入力してください` };
					}
					break;

				case "min":
					if (Number(val) < rule.value) {
						return { valid: false, message: rule.message || `${rule.value}以上の値を入力してください` };
					}
					break;

				case "max":
					if (Number(val) > rule.value) {
						return { valid: false, message: rule.message || `${rule.value}以下の値を入力してください` };
					}
					break;

				case "custom":
					if (typeof rule.validate === "function" && !rule.validate(val)) {
						return { valid: false, message: rule.message || "不正な値です" };
					}
					break;

				default:
					console.warn(`Unknown validation type: ${rule.type}`);
			}
		}

		return { valid: true, message: null };
	};


	// 追加の処理があれば実行
	const onFocus = (e) => {
		if (props.type=="password") {
			setType("text")
		}
		clearValueFirst()
		props.onfocus && props.onfocus(e)
	}
	const onBlur = (e) => {
		if (props.type=="password") {
			setType("password")
		}
		if (props.type == "number") {
			// IMEの仕様上、全角文字を入力中にBlurすると表示だけが残るため、空白を入れ直す
			if (e.target.value === "") {
				if (inputRef) {
					inputRef.current.value = "";
				}
			}
		}

		const validateInfo = Validate(e.target.value);
		console.log(validateInfo);
		setValidateInfo(validateInfo);

		props.onValidate && props.onValidate(validateInfo.valid)

		props.onblur && props.onblur(e)
	}
	const onChange = (e) => {
		setValue(e.target.value);
		props.onchange && props.onchange(e);
	}

 	// コンポーネントの返却
	if (props.isLoading)
	{
		return (
			<div className={'textinput-parent ' + (props.parentClassName ? props.parentClassName : "")} >
				<div
					/* set */
					id={props.name}
					className={"textinput loading"}
				>
				</div>
			</div>
		);
	}

	return (
		<div className={'textinput-parent ' + (props.parentClassName ? props.parentClassName : "")} >
			<input
				/* set */
				id={props.name}
				name={props.name}
				type={type}
				value={value}
				className={"textinput " + (props.className ? props.className : "")}
				title={props.default}
				placeholder={(props.placeholder) ? props.placeholder : "input " + ((props.type) ? props.type : "text")}
				aria-label={(props.placeholder) ? props.placeholder : "input " + ((props.type) ? props.type : "text")}
				disabled={props.disabled}
				autoComplete={props.autocomplete ? props.autocomplete : "new-off"}
				/* dataset */
				data-json={props.dataset}
				/* act */
				onFocus={onFocus}
				onBlur={onBlur}
				onChange={onChange}
				/* ref */
				ref={inputRef}
			/>
			<div className={'stack validate-message ' + (validateInfo.valid == false ? "show" : "")}>{validateInfo.message}</div>
		</div>
	);
}
export default TextInput
